export default __webpack_public_path__ + "static/media/dashboard_download_icon.cf8c861d.svg";